module.exports = __webpack_public_path__ + "static/media/about_black_ginssen_icon6.b038bfcf.png";